<template>
<span>
  <nav class="breadcrumb" id="results-nav">
      <ul>
        <li>
          <router-link :to="'/'">Protocol Library</router-link>
        </li>
          <li v-if="category" >
           <router-link :to='`/categories/${scrub(category)}`'>
            {{ category }}
          </router-link>
        </li>
        <li v-if="subcategory" >
           <router-link :to='`/categories/${scrub(category)}/${scrub(subcategory)}`'>
            {{ subcategory }}
          </router-link>
        </li>
      </ul>
  </nav>
  <main id="category">

    <aside class="refine">
      <h2 @click="home()">Protocol Library</h2>
      <Categories></Categories>
      <CalloutDocs></CalloutDocs>
    </aside>
    <section class="results">
      <div class="selected-category">
        <h4>Results For:
        <span v-for="(value, key) in queryOriginator()" class="query" v-if="value != null">
        "{{ value }}"&nbsp;
        </span></h4>
           <ProtocolPreview v-for="protocol in protocols" :protocol="protocol"></ProtocolPreview>
           <span v-if="protocols.length === 0">
           Don't see the protocol you need? We'll make it for you! Schedule a demo or chat with our Science team <a id="intercom-chat" href="#" onclick="window.Intercom('show');" data-gtm-action="click" data-gtm-category="Intercom" data-gtm-label="click">here</a>.
           </span>
      </div>
    </section>
  </main>
  </span>
</template>

<script>
  import Categories from './Categories'
  import ProtocolPreview from './ProtocolPreview.vue'
  import CalloutDocs from './CalloutDocs'
  import { scrubMixin } from '../mixins'
  import db from '../store/db'

  export default {
    name: 'ResultsView',
    mixins: [scrubMixin()],
    data () {
      return {
        category: 'N/A',
        subcategory: 'N/A',
        query: 'N/A',
        protocols: []
      }
    },
    components: {
      Categories,
      ProtocolPreview,
      CalloutDocs
    },
    created () {
      this.fetchProtocols()
    },
    watch: {
      '$route': 'fetchProtocols'
    },
    methods: {
      fetchProtocols () {
        let that = this
        if (this.$route.params.category) {
          let category = this.$route.params.category
          let subcategory = this.$route.params.subCategory
          db.getProtocolsByCategory(
            category.replace('-', ' '),
            subcategory ? subcategory.replace('-', ' ') : false
          ).then((protocols) => {
            that.protocols = protocols
          })
        } else if (this.$route.query.q) {
          let query = this.$route.query.q
          db.queryProtocols(query).then((response) => {
            that.protocols = response
          })
        }
      },
      queryOriginator () {
        let queryOrParams = Object.keys(this.$route.params).length > 0 ? this.$route.params : {'q': this.$route.query.q}
        this.category = queryOrParams.category
        this.subcategory = queryOrParams.subCategory
        return queryOrParams
      },
      home () {
        this.$router.push('/')
      }
    },
    updated: () => {
      window.scrollTo(0, 0)
    }
  }
</script>



// WEBPACK FOOTER //
// ResultsView.vue?631bed88